import React, { useEffect, useState } from 'react';
import { TextField, Button, Box, Grid, Select, InputLabel, MenuItem } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import DateAdapter from '@material-ui/pickers';
import "./stepper.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepConnector from "@material-ui/core/StepConnector";
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import Spinner from '../commons/Spinner/Spinner';
import clsx from "clsx";
import PropTypes from 'prop-types';
import Check from '@material-ui/icons/Check';
import { FormControl } from '@material-ui/core';
import { useHistory } from "react-router-dom";
import Niu from '../MainNav'
import PasoUnoForm from './PasoUnoForm'
import PasoDosForm from './PasoDosForm'
import PasoTresForm from './PasoTresForm'
import useStyles from './useStyles'
import { singleInputValidator } from '../commons/utils';
import Comprobante from '../Comprobante'
import { useForm } from "react-hook-form";
import { validateForm } from '../commons/utils';
import { getIsapres, getGenero, getPais, getRegion, getComuna, getRegionComuna, postFormulario} from '../commons/api';





/* define los colores de los iconos segun estado, activo o si aun no llega a ese paso  */
const useQontoStepIconStyles = makeStyles({
  root: {
    color: '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center'
  },

  circle: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },

  active: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? <Check className={classes.completed} /> : <div className={classes.circle} />}
    </div>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
};

/* metodo para customizar el background color de las lineas entre iconos, en este caso contiene una gradiante */
const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    "& $line": {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  completed: {
    "& $line": {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
})(StepConnector);

/* metodo para customizar el color de los iconos y su emplazamiento dentro de su contenedor */
const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',

  },
  active: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
  },
});

/* metodo para customización de los iconos del stepper */
function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  /* aquí se definen los iconos que llevara el stepper */
  const icons = {
    1: <AssignmentTurnedInIcon />,
    2: <AssignmentTurnedInIcon />,
    3: <AssignmentTurnedInIcon />,

  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};




const StepperTemplate = props => {

  const [activeStep, setActiveStep] = useState(0);
  const [hideStepper, setHideStepper] = useState(false)

  /* con el array steps, controlo la cantidad de pasos que tendrá, se puede dejar como '' si no se quiere mostrar */
  const steps = ['Paso 1', 'Paso 2', 'Paso 3']
  const classes = useStyles();
  const [loaded,setLoaded]=useState(false)
  const [spinner, setSpinner]=useState(false)
  const [reValid, setReValid]=useState(false)
  const [tituloH1, setTitiloH1] = useState('Guía de Servicios')
  const [titulo, setTitulo] = useState('Ingreso de consultas y opiniones')
  const [nombreRuta, setNombreRuta] = useState('Servicios')
  const [valorButton, setvalorButton] = useState('Siguiente')
  const { errors, setError } = useForm();
  const [isapres,setIsapres]=useState([])
  const [tipogenero,setTipoGenero]=useState([])

  /* variables formulario paso 1 */
  const [nombre, setNombre] = useState("");
  const [rut, setRut] = useState("");
  const [apellidoP, setApellidoP] = useState("");
  const [apellidoM, setApellidoM] = useState("");
  const [fechaNac, setFechaNac] = useState("");
  const [genero, setGenero] = useState([]);
  const [aseguradora, setAseguradora] = useState("");
  const [otro, setOtro] = useState("");
 
  /* variables formulario paso 2 */
  const [nombrePais, setNombrePais] =useState([]) 
  const [nombreRegion, setNombreRegion] =useState([]) 
  const [nombreComuna, setNombreComuna] =useState([]) 
  const [pais, setPais] =useState([])
  const [region, setRegion] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [comuna, setComuna] = useState("");
  const [telefono, setTelefono] = useState("");
  const [correo, setCorreo] = useState("");
  const [tipoCalle, setTipoCalle] = useState("");
  const [direccion, setDireccion] = useState("");
  const [nCalle, setNCalle] = useState("");
  const [departamento,  setDepartamento] = useState("");
  /* variables formulario paso 3 */

  const [tramitaciongroup, setTramitaciongroup] = useState("");
  const [antecedentesgenerales, setAntecedentesgenerales] = useState("");
  const [solicitudConcreta, setSolicitudConcreta] = useState("");



  const history = useHistory();
  useEffect(()=>{
    setLoaded(true)
    getIsapresApi()
    getGeneroApi()
    getPaisApi()
    getRegionApi()
  },[])

  useEffect(()=>{
    getComunaApi()
  },[ciudad])


  useEffect(() => {
    if(region !== "" ){
    
      getRegionComunaApi()

    }
      

  }, [region])


  const getIsapresApi = async () => {

    const resp=await getIsapres()
    const resp_status = (resp || {}).status;

    if (resp_status === 200) {
      let results = await resp
      let isapresAux = []
      results.data.map((item,index)=>{
        isapresAux.push(item)
        return null
      })
      setIsapres(isapresAux)
    }

  }

  const getGeneroApi = async () => {

    const resp=await getGenero()
    const resp_status = (resp || {}).status;

    if (resp_status === 200) {
      let results = await resp
      let generoAux = []
      results.data.map((item,index)=>{
        generoAux.push(item)
        return null
      })
      setTipoGenero(generoAux)
    }

  }


  const getPaisApi = async () => {

    const resp=await getPais()
    const resp_status = (resp || {}).status;

    if (resp_status === 200) {
      let results = await resp
      let paisAux = []
      results.data.map((item,index)=>{
        paisAux.push(item)
        return null
      })
      setNombrePais(paisAux)
    }

  }

  
  const getRegionApi = async () => {

    const resp=await getRegion()
    const resp_status = (resp || {}).status;

    if (resp_status === 200) {
      let results = await resp
      let regionAux = []
      results.data.map((item,index)=>{
        regionAux.push(item)
        return null
      })
      setNombreRegion(regionAux)
    }

  }

  

  const getRegionComunaApi = async () => {

    const resp = await getRegionComuna(region)
    const resp_status = (resp || {}).status;

    if (resp_status === 200) {
      let results = await resp
      let comunaAux = []
      results.data.comunas.map((comunas, index) => {
        
        comunas.map((item, indice) => {
          comunaAux.push(item)
          return null 
        })
        
        return null
      })
      //console.log(results.data)
      setNombreComuna(comunaAux)

    }
    
  }


  const getComunaApi = async () => {

    const resp=await getComuna(ciudad)
    const resp_status = (resp || {}).status;

    if (resp_status === 200) {
      let results = await resp
      let comunaAux = []
      results.data.comunas.map((item,index)=>{
        comunaAux.push(item)
        return null
      })
      setNombreComuna(comunaAux)
    }

  }
  const setDataFromElastic = (nombres, apellido_p, apellido_m, email, genero_id, fecha_nacimiento) => {

    setNombre(nombres)
    setApellidoP(apellido_p)
    setApellidoM(apellido_m)
    setCorreo(email)
    setReValid(!reValid)
  
  }


  const getStepContent = (stepIndex) => {
    switch (stepIndex) {
      case 0:
        return (
          <PasoUnoForm
            isapres={isapres}
            tipogenero={tipogenero}
            nombre={nombre}
            setNombre={setNombre}
            rut={rut}
            setRut={setRut}
            apellidoP={apellidoP}
            setApellidoP={setApellidoP}
            apellidoM={apellidoM}
            setApellidoM={setApellidoM}
            fechaNac={fechaNac}
            setFechaNac={setFechaNac}
            genero={genero}
            setGenero={setGenero}
            aseguradora={aseguradora}
            setAseguradora={setAseguradora}
            otro={otro}
            setOtro={setOtro}
            ValidateNombre={ValidateNombre}
            errors={errors}
            setError={setError} 
            setData = {setDataFromElastic}
            setSpinner={setSpinner}
            />
        )
      case 1:
        return (
          <PasoDosForm 
           nombrePais={nombrePais}
           nombreRegion={nombreRegion}
           nombreComuna={nombreComuna}
           pais={pais}
           setPais={setPais}
           region={region}
           setRegion={setRegion}
           ciudad={ciudad}
           setCiudad={setCiudad}
           comuna={comuna}
           setComuna={setComuna}
           telefono={telefono}
           setTelefono={setTelefono}
           tipoCalle={tipoCalle} 
           setTipoCalle={setTipoCalle}
           nCalle={nCalle}
           setNCalle={setNCalle}
           direccion={direccion}
           setDireccion={setDireccion}
           departamento={departamento}
           setDepartamento={setDepartamento}
           correo={correo}
           setCorreo={setCorreo}
           errors={errors}
           setError={setError} 
          />
        )
      case 2:
        return (
          <PasoTresForm 
            tramitaciongroup={tramitaciongroup}
            setTramitaciongroup={setTramitaciongroup}
            antecedentesgenerales= {antecedentesgenerales}
            setAntecedentesgenerales={setAntecedentesgenerales}
            solicitudConcreta={solicitudConcreta}
            setSolicitudConcreta={setSolicitudConcreta}
            errors={errors}
            setError={setError}
          />
        )
      default:
        return 'Paso incorrecto';
    }
  }

  const ValidateNombre = () => {


    if (nombre === '') {

      /* setea el mensaje de error */
      setError("Nombre", { type: "manual", message: "Debe seleccionar este campo" })
    } else {
      /* para esconder el mensaje de error */
      setError("Nombre", { type: "manual", message: "" })
    }

  }

  const handleNext = () => {

    if (activeStep === 0) {
      setvalorButton('Siguiente')
/*       if (!validateForm1Consultas(nombre, rut, apellidoP, apellidoM, fechaNac, genero, aseguradora, setError)) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1)
      } */

      let auxArr = [
        {
          dato:nombre, 
          errName:"Nombre", 
          otherValid:[]
        },
        {
          dato:rut, 
          errName:"Rut",
          otherValid:[{option:'rutValidation'}]
        },
        {
          dato:apellidoP, 
          errName:"apellidoP", 
          otherValid:[]
        }, 
        {
          dato:apellidoM, 
          errName:"apellidoM", 
          otherValid:[]
        }, 
        {
          dato:fechaNac, 
          errName:"fechaNac", 
          otherValid:[]
        }, 
        {
          dato:genero, 
          errName:"genero", 
          otherValid:[]
        },
        {
          dato:aseguradora, 
          errName:"aseguradora", 
          otherValid:[]
        }]

        if (!validateForm(auxArr, setError)) {
          setActiveStep((prevActiveStep) => prevActiveStep + 1)
        }

    }

    if (activeStep === 1) {
      setvalorButton('Siguiente')
      /*       if (!validateForm1Consultas(nombre, rut, apellidoP, apellidoM, fechaNac, genero, aseguradora, setError)) {
              setActiveStep((prevActiveStep) => prevActiveStep + 1)
            } */
      
            let auxArr = [
              {
                dato:pais, 
                errName:"pais", 
                otherValid:[]
              },
              {
                dato:region, 
                errName:"region", 
                otherValid:[]
              }, 
            
              {
                dato:comuna, 
                errName:"comuna", 
                otherValid:[]
              }, 
              {
                dato:telefono, 
                errName:"telefono", 
                otherValid:[]
              },

              {
                dato:correo, 
                errName:"correo", 
                otherValid:[]
              }]
      
            if (!validateForm(auxArr, setError)) {
              setvalorButton('Enviar')
              setActiveStep((prevActiveStep) => prevActiveStep + 1)
            }
      }

      if (activeStep === 2) {
        setvalorButton('Enviar')
        let auxArr = [
          {
            dato:tramitaciongroup, 
            errName:"tramitaciongroup", 
            otherValid:[]
          },
          
          
          {
            dato:antecedentesgenerales, 
            errName:"antecedentesgenerales", 
            otherValid:[]
          },
          {
            dato:solicitudConcreta, 
            errName:"solicitudConcreta", 
            otherValid:[]
          }

        ]

        if (!validateForm(auxArr, setError)) {
          setActiveStep((prevActiveStep) => prevActiveStep + 1)
          handleEnviar()
        }
      }




  };



  const handleBack = () => {
    setvalorButton('Siguiente')
    setActiveStep((prevActiveStep) => prevActiveStep - 1)

  };

  const handleNavClick = () => {
    console.log('poner aqui la navegacion')

  }

  const handleEnviar = () => {
      let auxRut = rut.replace(/\./g, "");
     
    
        let auxArr = 
        {
          
          tipo_tramitacion: 'consulta',  
          rut: auxRut,  
          nombres: nombre,
          apellido_pat: apellidoP,
          apellido_mat: apellidoM,
          fechaNac:fechaNac,
          genero_id: genero,
          aseguradora_id: aseguradora, 
          otro:otro,
          pais:pais,
          region_id: region,
          comuna_id: comuna,
          telefono: telefono,
          direccion_nombre: direccion,
          nCalle: nCalle,
          departamento: departamento,
          correo: correo,
          tramitaciongroup:tramitaciongroup,
          antecedentesgenerales: antecedentesgenerales,
          solicitudConcreta: solicitudConcreta
        }
        
   

      ///console.log("aqui", auxArr)
      ///setHideStepper(true)
     ///// let tempFolio = await postFormulario(auxArr)
     // setFolio(tempFolio)


  };

 
 // setTitulo('Comprobante')
  //setHideStepper(true)


  return (

    <>
      {/* el componente de navegacion */}
      <Niu titulo={tituloH1} nombreRuta={nombreRuta} handleNavClick={handleNavClick}></Niu>

      {/* el contenedor del formulario */}
      <div className={classes.contenedorForm + ' shadow'}  >

        <div>
          <h2 style={{ fontSize: 26 }} className="py-2">{titulo}</h2>

        </div>
        <div className={classes.root}>

          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel >{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          <div>
            {/*  acá se cargan las vistas de los elementos de formulario segun el paso en el que se esté, sería conveniente 
            crear componentes para cada paso */}
            {getStepContent(activeStep)}

            {/* aquí se pueden modificar los botones para avanzar o retroceder, dependiendo del valor del active step se pueden 
            hacer varias cosas curiosas */


            }
            <Box display="flex" justifyContent="space-between">

              <Grid style={{ marginLeft: 40, marginBottom: 20, paddingTop: 10 }}>



                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleBack}
                  hidden={activeStep === 0}
                >
                  Atrás
                </Button>

              </Grid>


              <Grid style={{ marginRight: 40, marginBottom: 20, paddingTop: 10 }}>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleNext}
                  hidden={activeStep === steps.length - 0}
                >
                  {valorButton}
                </Button>




               
              </Grid>


            </Box>
          </div>

        </div>
        <div>

        </div>
      </div>

    </>

  );
}
export default StepperTemplate;
